import React from "react";
import PropTypes from "prop-types";

class LocalErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  componentDidCatch(error, errorInfo) {
    console.error("LocalErrorBoundary caught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            color: "red",
            padding: "15px",
            border: "1px solid red",
            borderRadius: "4px",
            margin: "10px",
          }}
        >
          <h4 style={{ margin: "0 0 10px" }}>Error rendering details</h4>
          <pre
            style={{
              fontSize: "11px",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
            }}
          >
            {this.state.error && this.state.error.toString()}
          </pre>
          <pre
            style={{
              fontSize: "11px",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
              maxHeight: "150px",
              overflow: "auto",
            }}
          >
            {this.state.error && this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

LocalErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default LocalErrorBoundary;
